/* Window Resize Handles */
.resizeHandle {
  position: absolute;
  z-index: 10;
  touch-action: none;
}

.resizeHandle[data-edge="top"] {
  top: 0;
  left: 8px;
  right: 8px;
  height: 6px;
  cursor: ns-resize;
}

.resizeHandle[data-edge="bottom"] {
  bottom: 0;
  left: 8px;
  right: 8px;
  height: 6px;
  cursor: ns-resize;
}

.resizeHandle[data-edge="left"] {
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 6px;
  cursor: ew-resize;
}

.resizeHandle[data-edge="right"] {
  right: 0;
  top: 8px;
  bottom: 8px;
  width: 6px;
  cursor: ew-resize;
}

.resizeHandle[data-edge="top-left"] {
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  cursor: nwse-resize;
}

.resizeHandle[data-edge="top-right"] {
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  cursor: nesw-resize;
}

.resizeHandle[data-edge="bottom-left"] {
  bottom: 0;
  left: 0;
  width: 12px;
  height: 12px;
  cursor: nesw-resize;
}

.resizeHandle[data-edge="bottom-right"] {
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  cursor: nwse-resize;
}
